import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { AuthWrapper, ErrorMessage } from '../components';

const styles = {
  info: {
    margin: 10,
  },
};

const MissingRole = ({ logo, classes, children }) => (
  <AuthWrapper logo={logo}>
    <ErrorMessage errorMessage="Fehlende Berechtigungen" />
    <div className={classes.info}>
      Leider haben Sie keine Berechtigungen für diese Seite.
    </div>
    {children}
  </AuthWrapper>
);

MissingRole.propTypes = {
  classes: PropTypes.object.isRequired,
  logo: PropTypes.string.isRequired,
  children: PropTypes.node,
};

MissingRole.defaultProps = {
  children: null,
};

export default withStyles(styles)(MissingRole);
